import React from 'react'
import FormROValue from '../../../library/form/components/FormROValue1';
import FormLabel from '../../../library/form/components/FormLabel'
import FormWrapper from '../../../library/form/components/FormWrapper'
import DocRowContainer from '../../cmn/DocRowContainer'
import { UiBox, UiCol } from "../../../library/layout/Index";

const ProfileIdentityRow = (props) => {
    const { formObject, rowKey } = props;


    return (
        <UiCol>
            <DocRowContainer formObject={formObject} rowKey={rowKey} containerClass="uiRowWrap10" >
                <UiBox>
                    <ul>
                        <div>
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "name" }} className="uiHeaderElement" 
                            />
                        </div>
                        <div>
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "gender" }} className=""
                            />
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "dateOfBirth" }} className="uiSpacerL10"
                            />
                        </div>
                        <div>
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "identityType" }} className="" 
                            />
                            :
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "number" }} className="uiSpacerL10"
                            />
                        </div>

                        <div >
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "issuedLocation" }}
                            />
                            , 
                            <FormROValue formObject={formObject} rowKey={rowKey}
                                action={{ paramName: "issuedCountry" }}
                            />
                        </div>
                        <div>

                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "issuedOn" }} />
                            <FormWrapper customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "expiryOn" }} >
                                -
                                <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "expiryOn" }} />
                            </FormWrapper>
                        </div>
                        <div>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "hasNoexpiry" }} value="Has No Expiry" />
                            </span>
                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "hasNoexpiry" }} />
                        </div>
                        <div>
                            <span className="uiLbl">
                                <FormLabel formObject={formObject} rowKey="" action={{ paramName: "isDefault" }} value="Set Default" />
                            </span>
                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "isDefault" }} />
                        </div>
                        <div>

                            <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "remarks" }} />
                        </div>
                    </ul>
                </UiBox>
            </DocRowContainer>
        </UiCol>
    )
}

export default ProfileIdentityRow